import React, { Fragment } from 'react'

const SortCriteriaCompact = ({
    sortCriteria,
    selectedSortingValue,
    onSortingChange,
}) => {
    const selectedOptionValue = selectedSortingValue
        ? selectedSortingValue
        : [
              ...sortCriteria.filter((sort) => sort.selected === true),
              ...sortCriteria,
          ][0].value
    return (
        <ul className="faceted-search__sublist">
            {sortCriteria &&
                sortCriteria.map(({ text, value, selected }, index) => (
                    <Fragment>
                        <li
                            key={`sorteriaCompact-${index}`}
                            className="faceted-search__item"
                            role="faceted-search-item"
                        >
                            <label className="faceted-sorting">
                                <input
                                    className="faceted-sorting__input"
                                    type="checkbox"
                                    onChange={() => onSortingChange(value)}
                                    checked={value == selectedOptionValue}
                                />
                                <span className="faceted-sorting__label">
                                    {text}
                                </span>
                            </label>
                        </li>
                        <hr />
                    </Fragment>
                ))}
        </ul>
    )
}

export default SortCriteriaCompact
